import { inject } from "@angular/core";
import {
  CanActivateFn,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "./auth.service";
import { isTeams } from "../teams";
import { TeamsService } from "../teams.service";
import { PwaService } from "../services/pwa-service";

export const authGuard: CanActivateFn = (route, state) => {
  console.log("[TEAMS] AuthGuard");

  const authService = inject(AuthService);
  const router = inject(Router);
  const teamsService = inject(TeamsService);
  const pwaService = inject(PwaService);

  console.log("Token:", localStorage.getItem("token"));
  console.log("isAuthenticated:", authService.isAuthenticated());

    console.log("GUARD URL:", state.url);
    console.log("AUTH:", authService.isAuthenticated());

  if (!authService.isAuthenticated()) {

    pwaService.clearStorageKeepingPwaSettings();
     //localStorage.clear();    
      router.navigate(['/authenticate']);
    //authService.logout();
    return false;        
  }

  if (teamsService.isTeams()) {
    console.log("[TEAMS] AuthGuard");

    const lastRoute = sessionStorage.getItem("lastRoute");

    console.log("[TEAMS] LastRoute", lastRoute);
    console.log("[TEAMS] state.url", state.url);

    if (lastRoute && state.url === "/") {
      console.log("[TEAMS] Restoring route:", lastRoute);
      return router.parseUrl(lastRoute);
    }
  }

  return true;
};
